import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';
import { FaCamera, FaEye, FaRegLightbulb } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Icon from '../../assets/Icon-white.png';
import step01 from '../../assets/images/step01.png';
import step02 from '../../assets/images/step02.png';
import './styles.css';
import '../../App.css';
import Lottie from 'react-lottie';
import iconLoading from '../../assets/icons/loading.json';

function Component({ history }) {
  const { t } = useTranslation();

  const steps = [
    {
      id: 1,
      text: t('howToPhotographIris.steps.step1')
    },
    {
      id: 2,
      text: t('howToPhotographIris.steps.step2')
    },
    {
      id: 3,
      text: t('howToPhotographIris.steps.step3')
    },
    {
      id: 4,
      text: t('howToPhotographIris.steps.step4')
    },
    {
      id: 5,
      text: t('howToPhotographIris.steps.step5')
    },
    {
      id: 6,
      text: t('howToPhotographIris.steps.step6')
    }
  ];

  const tips = [
    t('howToPhotographIris.tips.tip1'),
    t('howToPhotographIris.tips.tip2'),
    t('howToPhotographIris.tips.tip3'),
    t('howToPhotographIris.tips.tip4'),
  ];

  return (
    <div className="container">
      <div className="col-12 bodyPage">
        <div className="text-center">
          <div className="col-12">
            <h1 id="logo">e-iris.</h1>
          </div>
          <h3>{t('howToPhotographIris.title')}</h3>
          <p>{t('howToPhotographIris.subtitle')}</p>
        </div>

        <div className="row steps-container align-items-center">
          <div className="col-12 col-md-6 step-image">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              <img src={step02} alt="Dicas para fotografar íris" className="img-fluid" />
            </motion.div>
          </div>
          <div className="col-12 col-md-6">
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              {steps.map((step, index) => (
                <div key={step.id} className="step-item-how">
                  <p><b>{step.id}.</b> {step.text}</p>
                </div>
              ))}
            </motion.div>
          </div>
        </div>

        <br /><br />
        <div className="row align-items-center">
          <div className="col-12 col-md-7">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6, duration: 0.5 }}
            >
              <h4>{t('howToPhotographIris.tips.title')}</h4>
              <br />
              <ul>
                {/*<li className="tips-item">{t('howToPhotographIris.tips.tip1')}</li>*/}
                <li className="tips-item">{t('howToPhotographIris.tips.tip2')}</li>
                <li className="tips-item">{t('howToPhotographIris.tips.tip3')}</li>
                <li className="tips-item">{t('howToPhotographIris.tips.tip4')}</li>
              </ul>
            </motion.div>
          </div>
          <div className="col-12 col-md-5 step-image">
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.8, duration: 0.5 }}
            >
              {/*<img src={step01} alt="Como fotografar íris" className="img-fluid" />*/}
            </motion.div>
          </div>
        </div>

        <br /><br />
        <div className="examples">
          <p><b>{t('howToPhotographIris.examples.good.title')}</b></p>
          <div className="row examplesIris">
            {[1, 2, 3].map(num => (
              <div key={num} className="col-12 col-sm-6 col-md-4 text-center itemExemploIris">
                <img
                  src={`https://storage.googleapis.com/e-iris-businesses/exemplos/exemplo-iris-${num}.JPG`}
                  alt={`Exemplo bom ${num}`}
                />
                <p>{t(`howToPhotographIris.examples.good.example${num}`)}</p>
              </div>
            ))}
          </div>

          <p><b>{t('howToPhotographIris.examples.bad.title')}</b></p>
          <div className="row examplesIris">
            {[4, 5, 6].map(num => (
              <div key={num} className="col-12 col-sm-6 col-md-4 text-center itemExemploIris">
                <img
                  src={`https://storage.googleapis.com/e-iris-businesses/exemplos/exemplo-iris-${num}.JPG`}
                  alt={`Exemplo ruim ${num}`}
                />
                <p>{t(`howToPhotographIris.examples.bad.example${num - 3}`)}</p>
              </div>
            ))}
          </div>
        </div>

        <br /><br />
        <div className="row">
          <div className="col-12 text-center">
            <p style={{ fontSize: 14 }}>
              {t('howToPhotographIris.footer')}{' '}
              <b style={{ fontSize: 20 }}>
                <a href="https://eiris.app" target="_blank" rel="noopener noreferrer">e-iris.</a>
              </b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Component;
